import React from 'react';
// components
import Skeleton, { SkeletonProps } from '@material-ui/lab/Skeleton';
import List, { ListProps } from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

interface Props {
  itemsCount: number;
  ListProps?: Partial<ListProps>;
  SkeletonProps?: Partial<SkeletonProps>;
}

export const ListItemSkeleton = (props: Props): JSX.Element => {
  const { itemsCount, ListProps, SkeletonProps } = props;
  const items = Array.from({ length: itemsCount }, (_value, index) => (
    <ListItem key={ index }> <Skeleton variant="rect" width="100%"  { ...SkeletonProps }/></ListItem>
  ));

  return (
    <List { ...ListProps }>{ items }</List>
  );
};
